import RecycleIcon from '@/common/assets/icons/recycle.svg?react';
import LoadingButton from '@/common/components/base/button/loadingButton';
import useToast from '@/common/store/alert/useToast';
import { ParticipantIncidentActivateType } from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentActivate/ParticipantIncidentActivate.type';
import { activateMutationOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/activate/activateQueryOptions';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';

const ParticipantIncidentActivate = ({
  id,
}: ParticipantIncidentActivateType) => {
  const [loadingId, setLoadingId] = useState(0);
  const query = useQueryClient();
  const { mutateAsync: activateParticipant, isPending } = useMutation(
    activateMutationOptions(),
  );

  const param = useParams();
  const showAlert = useToast((state) => state.showAlert);
  const { isPending: loading } = useQuery(
    participantsIncidentQueryOptions({ id: param.id! }),
  );
  return (
    <Flex
      onClick={() => {
        setLoadingId(id);
        return activateParticipant({
          id: param.id!,
          formData: { damaged_pk: id },
        }).then(() => {
          showAlert({
            type: 'success',
            description: 'زیاندیده فعال شد!',
          });
          query.invalidateQueries({
            queryKey: participantsIncidentQueryOptions({ id: param.id! })
              .queryKey,
          });
        });
      }}
      key={id}
      height={'26px'}
      textWrap={'nowrap'}
      width={'350px'}
      alignItems={'center'}
      justifyContent={'start'}
    >
      <LoadingButton
        gap="5px"
        fontSize={'11px'}
        fullWidth
        variant="text"
        color={'success'}
        loadingColor={'success'}
        loading={(isPending || loading) && loadingId === id}
      >
        <RecycleIcon
          className={css({
            position: 'relative',
            top: '1px',
          })}
        />
        فعال سازی
      </LoadingButton>
    </Flex>
  );
};
export default ParticipantIncidentActivate;
